/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Frame_RateInputs */



/**
* | output |
* | --- |
* | "Target Frame Rate" |
*
* @param {Target_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_frame_rate = /** @type {((inputs?: Target_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fréquence d’images cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielbildrate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza fotogrammi target")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая частота кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de fotogramas objetivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标帧率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットフレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फ्रेम दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros alvo")
	return /** @type {LocalizedString} */ ("Target Frame Rate")
});